import { icon } from "../iconsKit";
import type { DockModel } from "./armouryModel";

/**
 * The readiness dock (thumb zone): "Next · Level N", the hub strip's state words and colour, the gear meter as the
 * hub shows it (percent of the level's target, a white tick at the Ready line), and Battle. The meter is a button: it
 * opens "Get stronger" in the strip above. (M30 #15: the Equip best button and its preview are gone — Kevin: "the
 * Equip best button doesn't act as expected: remove that section entirely"; gear goes on from the item card.)
 */
export function dockHtml(m: DockModel, level: number): string {
  const meter = m.showMeter
    ? `<span class="mbar"><i class="now" style="transform:scaleX(${m.nowPct / 100})"></i><i class="tick" style="left:${m.readyPct}%"></i></span>`
    : `<span class="nums free">${m.gearFrom !== null ? `Gear counts from Level ${m.gearFrom}` : "No gear target"}</span>`;
  const nums = m.showMeter ? `<span class="nums"><b class="nowv">${m.nowPct}%</b><span class="rd">/${m.readyPct}%</span></span>` : "";
  return `<div class="arm-dock tone-${m.tone}">
    <button type="button" class="meter" aria-label="${m.title}: gear ${m.nowPct}% of the level's target. Tap for ways to get stronger">
      <span class="k"><span class="state ${m.tone}">${m.title}</span>${nums}</span>
      ${meter}
    </button>
    <button type="button" class="btn ${m.readiness.state === "ready" ? "green" : "gold"} best battle disp">${icon("sword", 18)}Battle<small>Level ${level}</small></button>
  </div>`;
}
